export const PROFILE_CHANGE_REQUEST = 'PROFILE_CHANGE_REQUEST';
export const PROFILE_CHANGE_REQUEST_SUCCESS = 'PROFILE_CHANGE_REQUEST_SUCCESS';
export const PROFILE_CHANGE_REQUEST_ERROR = 'PROFILE_CHANGE_REQUEST_ERROR';

export const CANCEL_REDIRECT = 'CANCEL_REDIRECT';